import type { Assistant, AssistantFeature } from './types';

export const ENGINEERING_ASSISTANT_ID = 'engineering';
export const FLIGHT_SPEED_FEATURE_ID = 'flightSpeed';
export type EngineeringStrategy = 'flight' | 'fuel';

export const engineeringAssistant: Assistant = {
  id: ENGINEERING_ASSISTANT_ID,
  name: '工程助理',
  description: '已分配航线的飞机 ≥50 架，或经营至第 104 周后解锁。招募后可逐架飞机调整巡航速度，在燃油与航班耗时之间做权衡。',
  featureIds: [FLIGHT_SPEED_FEATURE_ID],
  unlocked: (state) => state.aircraft.filter((a) => a.routeIds.length).length >= 50 || state.week >= 104,
  unlockRequirement: '已分配航线的飞机 ≥50 架，或经营至第 104 周',
  recruitCost: 80_000,
  weeklySalary: 3_500,
};

export const flightSpeedFeature: AssistantFeature = {
  id: FLIGHT_SPEED_FEATURE_ID,
  name: '飞行速度调整',
  description: '允许将单架飞机的巡航速度在 0.92~1.08 之间调整。提速会增加燃油但减少飞行小时；减速则相反。',
  assistantId: ENGINEERING_ASSISTANT_ID,
};
